export default {
  en: {
    // 页面标题和主要文案
    banner: {
      title1: "Empower Cloud Business Growth",
      title2: "Unified Multi-Cloud & AI Platform",
      description:
        "Unified management, cost optimization, and enhanced efficiency for global cloud infrastructure.",
      contactButton: "Contact Now",
    },

    // 数据展示
    data: {
      label1: "Covering Mainstream Cloud & AI Capabilities",
      label2: "Average Cloud Cost Optimization Improvement",
      label3: "R&D and Operations Efficiency Improvement",
    },

    // 合作伙伴
    partners: {
      title: "Trusted by Leading Global Cloud Providers",
    },

    // 解决方案
    solution: {
      title: "Solutions | Making Complex Multi-Cloud Management Simple",
      problems: {
        procurement: {
          title: "Resources & Pricing Layer",
          issue1: "Complex multi-cloud vendor policies",
          issue2: "Cumbersome pricing system, difficult to calculate profits",
        },
        usage: {
          title: "Delivery Layer",
          utilization: "Diverse customer needs",
          waste: "Complex solution combinations, high affinity",
        },
        operation: {
          title: "Operations Layer",
          issue1: "Complex customer, billing, and payment term management",
          issue2: "High manual reconciliation costs, low settlement efficiency",
        },
      },
      content: {
        subtitle: "Intelligent Multi-Cloud Management",
        title:
          "Solve cloud resale difficulties, increase profits, and lighten delivery.",
        description:
          "As cloud computing becomes the foundation of enterprise IT architecture, multi-cloud environments have gradually become the norm, bringing increasingly prominent challenges of resource fragmentation, cost complexity, and operational coordination. By building an intelligent multi-cloud management platform that unifies management of multiple cloud providers and various cloud resources, covering the entire process of procurement, usage, and operations, we help enterprises improve resource visibility and controllability, achieve refined cost management and automated operations, and build a stable, efficient, and continuously evolving cloud infrastructure system.",
        cards: {
          procurement: "One-Stop Cloud Procurement",
          devfinops: "DevFinOps Cost Reduction",
          learnMore: "Learn More",
          action: "Learn Now",
        },
      },
    },

    // 认证资质
    certificates: {
      title: "Our Expertise, Recognized by the Industry",
      items: {
        cert1: {
          title: "AWS<br />Advanced Partner",
          alt: "AWS Advanced Partner",
        },
        cert2: {
          title: "AWS Generative<br />AI Competency",
          alt: "AWS Generative AI Competency",
        },
        cert3: {
          title: "AWS Migration &<br />Modernization Competency",
          alt: "AWS Migration & Modernization Competency",
        },
        cert4: {
          title: "Google Cloud<br />Partner",
          alt: "Google Cloud Partner",
        },
        cert5: {
          title: "Oracle<br />Partner Network Member",
          alt: "Oracle Partner Network Member",
        },
        cert6: {
          title: "Alibaba Cloud<br />Channel Partner",
          alt: "Alibaba Cloud Channel Partner",
        },
        cert7: {
          title: "Kubernetes<br />Certified Administrator",
          alt: "Kubernetes Certified Administrator",
        },
        cert8: {
          title: "AWS Certified<br />Solutions Architect Professional",
          alt: "AWS Certified Solutions Architect Professional",
        },
        cert9: {
          title: "Google Cloud<br />Professional Cloud Architect",
          alt: "Google Cloud Professional Cloud Architect",
        },
        cert10: {
          title: "Feifan Research<br />2024 CHINA AIGC100",
          alt: "Feifan Research 2024 CHINA AIGC100",
        },
      },
    },

    // 优势展示
    advantages: {
      title: "Why Choose Us?",
      items: {
        cost: {
          title: "More Competitive Profit Margins",
          description:
            "With top cloud vendor partnerships and integrated resources, we offer stable, sustainable resale margins to boost your gross profit.",
        },
        convenience: {
          title: "One-Stop Cloud Resale",
          description:
            "Buy, manage, and settle top clouds—AWS, Alibaba Cloud, Tencent Cloud, Google Cloud—all in one place. Start your cloud resale fast.",
        },
        experience: {
          title: "Cloud Resale Experience",
          description:
            "Extensive international experience enables us to deliver stable, compliant, and replicable cloud resale solutions.",
        },
        service: {
          title: "Professional Service Guarantee",
          description:
            "We not only provide products, but also provide 7x24 hour expert team services, responding to any of your needs at any time.",
        },
      },
      contactButton: "Contact Us",
    },
  },
  zh: {
    // 页面标题和主要文案
    banner: {
      title1: "赋能企业云转售业务增长",
      title2: "一站式多云与AI资源管理平台",
      description:
        "聚合主流云厂商与大模型资源，帮助企业统一管理、降低成本、提升研发与运维效率，实现全球云资源的可视化与智能化运营。",
      contactButton: "立即联系",
    },

    // 数据展示
    data: {
      label1: "覆盖主流云与 AI 能力",
      label2: "平均云成本优化提升",
      label3: "研发与运维效率提升",
    },

    // 合作伙伴
    partners: {
      title: "深受全球主流云厂商信赖",
    },

    // 解决方案
    solution: {
      title: "解决方案｜让复杂的多云管理变得简单",
      problems: {
        procurement: {
          title: "资源与价格层",
          issue1: "多云厂商政策复杂",
          issue2: "价格体系繁琐，利润难测算",
        },
        usage: {
          title: "交付层",
          utilization: "客户需求多样",
          waste: "方案组合复杂，亲和度高",
        },
        operation: {
          title: "运营层",
          issue1: "客户、账单、账期管理复杂",
          issue2: "人工对账成本高，结算效率低",
        },
      },
      content: {
        subtitle: "智能化多云管理",
        title: "破解“云难卖、利润低、交付重”困局  全面赋能云资源转售业务增长",
        description:
          "随着云计算成为企业 IT 架构的底座能力，多云环境逐渐成为常态，随之而来的资源分散、成本复杂与运维协同问题也愈发突出。通过构建智能化多云管理平台，统一管理多云厂商与多类云资源，覆盖采购、使用与运维全流程，帮助企业提升资源可视性与可控性，实现精细化成本管理与自动化运维，构建稳定、高效、可持续演进的云基础设施体系。",
        cards: {
          procurement: "一站式云采购解决方案",
          devfinops: "DevFinOps多云降本解决方案",
          learnMore: "了解更多",
          action: "立即了解",
        },
      },
    },

    // 认证资质
    certificates: {
      title: "我们的专业，业界共睹",
      items: {
        cert1: {
          title: "AWS<br />高级合作伙伴",
          alt: "AWS 高级合作伙伴",
        },
        cert2: {
          title: "AWS生成式<br />AI服务能力认证",
          alt: "AWS生成式AI服务能力认证",
        },
        cert3: {
          title: "AWS迁移与现代化<br />服务能力认证",
          alt: "AWS迁移与现代化服务能力认证",
        },
        cert4: {
          title: "谷歌云<br />合作伙伴",
          alt: "谷歌云合作伙伴",
        },
        cert5: {
          title: "甲骨文<br />合作伙伴网络成员",
          alt: "甲骨文合作伙伴网络成员",
        },
        cert6: {
          title: "阿里云<br />渠道合作伙伴",
          alt: "阿里云渠道合作伙伴",
        },
        cert7: {
          title: "Kubernetes<br />认证管理员",
          alt: "Kubernetes认证管理员",
        },
        cert8: {
          title: "AWS<br />认证解决方案架构师专业级",
          alt: "AWS认证解决方案架构师专业级",
        },
        cert9: {
          title: "谷歌云<br />认证专业级云架构师",
          alt: "谷歌云认证专业级云架构师",
        },
        cert10: {
          title: "非凡产研<br />2024 CHINA AIGC100",
          alt: "2024 CHINA AIGC100",
        },
      },
    },

    // 优势展示
    advantages: {
      title: "为什么选择我们？",
      items: {
        cost: {
          title: "更具竞争力的利润",
          description:
            "托主流云厂商官方合作与资源整合能力，提供稳定、可持续的云资源转售空间，助力提升业务毛利。",
        },
        convenience: {
          title: "一站式云资源转售能力",
          description:
            "聚合 AWS、阿里云、腾讯云、Google Cloud 等主流云厂商，统一采购、统一管理、统一结算，快速开展云转售业务。",
        },
        experience: {
          title: "云转售与服务经验",
          description:
            "依托集团多年企业级客户服务与国际化经验，深度理解云转售业务模式，为合作伙伴提供稳定、合规、可复制的云业务支撑。",
        },
        service: {
          title: "专业的服务保障",
          description:
            "我们不仅提供产品，更提供 7x24 小时的专家团队服务，随时响应您的任何需求。",
        },
      },
      contactButton: "联系我们",
    },
  },

  ja: {
    // 页面标题和主要文案
    banner: {
      title1: "企業のデジタル変革を推進",
      title2: "ワンストップマルチクラウド&AI<br />リソース管理プラットフォーム",
      description:
        "主流クラウドプロバイダーと大規模モデルリソースを統合し、企業の統一管理、コスト削減、研究開発と運用効率の向上を支援し、グローバルクラウドリソースの可視化とインテリジェント運用を実現します。",
      contactButton: "お問い合わせ",
    },

    // 数据展示
    data: {
      label1: "主流クラウド&AI機能をカバー",
      label2: "平均クラウドコスト最適化向上",
      label3: "研究開発と運用効率向上",
    },

    // 合作伙伴
    partners: {
      title: "グローバルクラウドに信頼されています",
    },

    // 解决方案
    solution: {
      title: "ソリューション｜複雑なマルチクラウド管理をシンプルに",
      problems: {
        procurement: {
          title: "調達レイヤー",
          issue1: "マルチクラウド価格比較に時間がかかり、調達ルールが複雑",
          issue2: "ベンダーポリシーが不透明で、情報格差が顕著",
        },
        usage: {
          title: "使用レイヤー",
          utilization: "リソース使用率：",
          waste: "アイドルリソースの無駄：",
        },
        operation: {
          title: "運用レイヤー",
          issue1: "権限の混乱、コンプライアンス監査の困難",
          issue2: "ビジネス設定のオンライン化に24時間以上",
        },
      },
      content: {
        subtitle: "インテリジェントマルチクラウド管理",
        title:
          "「クラウド選択の困難、クラウド使用の高コスト」のジレンマを解決し、クラウド効率の飛躍を推進",
        description:
          "クラウドコンピューティングが企業ITアーキテクチャの基盤となる中、マルチクラウド環境が徐々に標準となり、リソースの分散、コストの複雑さ、運用の協調問題がますます顕著になっています。インテリジェントなマルチクラウド管理プラットフォームを構築し、複数のクラウドプロバイダーと多様なクラウドリソースを統一管理し、調達、使用、運用の全プロセスをカバーすることで、企業のリソースの可視性と制御性を向上させ、精密なコスト管理と自動化された運用を実現し、安定的で効率的かつ持続的に進化するクラウドインフラストラクチャシステムを構築します。",
        cards: {
          procurement: "ワンストップクラウド調達ソリューション",
          devfinops: "DevFinOpsマルチクラウドコスト削減ソリューション",
          learnMore: "詳細を見る",
          action: "今すぐ学ぶ",
        },
      },
    },

    // 认证资质
    certificates: {
      title: "私たちの専門性、業界で認められています",
      items: {
        cert1: {
          title: "AWS<br />アドバンスドパートナー",
          alt: "AWS アドバンスドパートナー",
        },
        cert2: {
          title: "AWS生成式<br />AIコンピテンシー",
          alt: "AWS生成式AIコンピテンシー",
        },
        cert3: {
          title: "AWSマイグレーション&<br />モダナイゼーションコンピテンシー",
          alt: "AWSマイグレーション&モダナイゼーションコンピテンシー",
        },
        cert4: {
          title: "Google Cloud<br />パートナー",
          alt: "Google Cloudパートナー",
        },
        cert5: {
          title: "Oracle<br />パートナーネットワークメンバー",
          alt: "Oracleパートナーネットワークメンバー",
        },
        cert6: {
          title: "Alibaba Cloud<br />チャネルパートナー",
          alt: "Alibaba Cloudチャネルパートナー",
        },
        cert7: {
          title: "Kubernetes<br />認定管理者",
          alt: "Kubernetes認定管理者",
        },
        cert8: {
          title: "AWS認定<br />ソリューションアーキテクトプロフェッショナル",
          alt: "AWS認定ソリューションアーキテクトプロフェッショナル",
        },
        cert9: {
          title: "Google Cloud<br />プロフェッショナルクラウドアーキテクト",
          alt: "Google Cloudプロフェッショナルクラウドアーキテクト",
        },
        cert10: {
          title: "2024 CHINA<br />AIGC100",
          alt: "2024 CHINA AIGC100",
        },
      },
    },

    // 优势展示
    advantages: {
      title: "なぜ私たちを選ぶのか？",
      items: {
        cost: {
          title: "大幅なコスト節約",
          description:
            "市場平均を下回るクラウドリソース価格を提供し、お客様のすべての予算をより価値のあるものにします。",
        },
        convenience: {
          title: "究極の調達利便性",
          description:
            "一つのパートナーで、すべての主流クラウドを調達でき、より柔軟な支払い方法を享受し、煩雑なプロセスとお別れできます。",
        },
        experience: {
          title: "深い業界蓄積",
          description:
            "CycorはClickLink（SZ301171）傘下のブランドで、10年以上の企業国際化サービス経験に支えられています。",
        },
        service: {
          title: "専門的なサービス保障",
          description:
            "私たちは製品を提供するだけでなく、7x24時間の専門チームサービスを提供し、お客様のあらゆるニーズにいつでも対応します。",
        },
      },
      contactButton: "お問い合わせ",
    },
  },
};
